<template>
    <v-container>
        <v-card style="border-radius: 8px;">
            <v-layout>
                <v-flex xs2>
            <v-avatar
            :size="60"
            >
                <v-img
                    class="elevation-6 ml-5"
                    :src="cpageDetails.imageurl"
                ></v-img>
            </v-avatar>
            </v-flex>
            <v-flex xs6 class="mt-1">
                <div class="title font-weight-regular mt-3"> {{cpageDetails.name}} </div>
            </v-flex>
            <v-flex xs2 class="mt-1">
                <v-btn flat round class="mt-2" color="primary"  @click="disconnectPage">disconnect</v-btn>
            </v-flex>
            <v-flex xs2 class="mt-1">
                <v-btn flat round class="mt-2" color="primary"  @click="refreshPage">refresh</v-btn>
            </v-flex> 
            </v-layout>
        </v-card>
        <v-snackbar
            v-model="snackbar.status"
            bottom
            left
            :timeout="snackbar.timeout"
            >
            {{snackbar.update}}
        </v-snackbar>       
    </v-container>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import router from '../router'
import store from '../store'
import {db} from '@/plugins/firebase.js';
export default {
    data(){
        return{
            
        }
    },
    methods:{
        disconnectPage(){              
             let pageid = this.$store.state.pageDetails
             FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api(
                    "/"+pageid.page_id+"/subscribed_apps?access_token=" +pageid.accessToken,
                    'DELETE',
                    function (response) { 
                        console.log(pageid.page_id+' Bot Deleted')                         
                        router.push('/settings-newbot')              
                    });
                    }
                else{    
                console.log("unable to get login status") 
                }     
                }) 
        },
        refreshPage(){
             let status = true
             let timeout = 3000
             let update = "Bot freshed"
             let page_id = this.$store.state.pageDetails
             console.log(page_id)   
            
             FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {
                    let pageid = page_id.page_id 
                    let userAccessToken = page_id.userAccessToken                    
                    FB.api(
                    "/"+page_id.page_id+"/subscribed_apps?access_token=" +page_id.accessToken,
                    'DELETE',
                    function (response) {
                        FB.api(
                        "/"+page_id.page_id+"/subscribed_apps?access_token=" +page_id.accessToken,
                        'POST',
                        {"subscribed_fields":"messages,messaging_postbacks,messaging_referrals,feed"},
                        function (response) { 

                            let res2 = axios({
                                    method: "get",
                                    url: "https://small-umbra.glitch.me/token",
                                    data: null,
                                    params: {pageid,userAccessToken}
                                })
                            .then(response => {
                                store.dispatch('aupdatesnackbarstatus',{status,update,timeout})
                                console.log(response)
                            })
                            .catch(error => {
                            console.log(error)
                            })

                            // db.collection("pages").doc(pageid.page_id)
                            // .update({
                            //     "access_token": pageid.accessToken
                            // }).then(
                            //     store.dispatch('aupdatesnackbarstatus',{status,update,timeout})
                            //     )                  
                        });                  
                    });                    
                    }
                else{    
                console.log("unable to get login status") 
                }     
                })
        },
        checkStatus(){
            console.log("checking")
            if(this.$store.state.pageDetails.subscribed == false)
            {
                router.push('/settings-newbot')
            }
        }

    },
    created(){

    },
    computed:{
        cpageDetails(){
            this.checkStatus()
            console.log(this.$store.state.pageDetails)
            return this.$store.state.pageDetails           
        },
        snackbar(){
            return this.$store.state.snackbar
        }
    }    
}
</script>
